import React from 'react';
import {connect} from "react-redux";
import {addRecipeIngredient} from "../../actions/updateFirestoreData/userData/addRecipeIngredients";
import {Button, Typography, Grid, Dialog, DialogActions, DialogContent ,DialogTitle, Input} from "@material-ui/core";
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';


/**
 * This class will add all recipe's ingredients into user's grocery list
 */
class ButtonAddIngredients extends React.Component {
    state ={
        number:this.props.recipe.peoples,
        open:false
    };

    handleInputChange = (event) => {
        if(event.target.value !== '') {this.limit(Number(event.target.value));}
    };

    handleBlur = () => {
        this.limit(this.state.number);
    };

    limit = (value) =>{
        if (value < 1) {        this.setState({number : 1});}
        else if(value > 20){    this.setState({number : 20});}
        else{                   this.setState({number : value});}
    };

    handleClickOpen = () => {
        this.setState({open:true});
    };

    handleClose = () => {
        this.setState({open:false});
    };
    addToMyList = async() =>{
        this.handleClose();
        await this.props.addRecipeIngredient({
            recipe:this.props.recipe,
            userPseudo:this.props.auth.pseudo,
            number:this.state.number,
            recipeIngredients:this.props.recipeIngredients});
    };

    render() {
        return (
            <Grid style={{width:"100%", flex:1}}>

                <Button style={{width:"100%", flex:1, display:"flex", justifyContent:"flex-start"}} onClick={this.handleClickOpen}>
                    <AddShoppingCartIcon/><Typography className={this.props.typoClass}>Ma liste</Typography>
                </Button>

                <Dialog disableBackdropClick disableEscapeKeyDown open={this.state.open} onClose={this.handleClose}>
                <DialogTitle>Quantité pour : </DialogTitle>
                <DialogContent>
                    <form style={{display: 'flex', flexWrap: 'wrap',}}>
                        <Input
                            value={this.state.number}
                            margin="dense"
                            onChange={this.handleInputChange}
                            onBlur={this.handleBlur}
                            inputProps={{
                                step: 1,
                                min: 1,
                                max: 20,
                                type: 'number',
                                'aria-labelledby': 'input-slider',
                            }}
                        />
                    </form>
                    {this.props.recipeIngredients.map((ingredient, index2) =>
                        <Typography key={index2} paragraph> {ingredient.quantity && ingredient.quantity !=="" ? (parseInt(ingredient.quantity)*this.state.number/this.props.recipe.peoples).toFixed(2) :""} {ingredient.name} </Typography>)}
                </DialogContent>

                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.addToMyList} color="primary">
                        <AddShoppingCartIcon/>
                    </Button>
                </DialogActions>
            </Dialog>
            </Grid>
        )
    }
}


const mapStateToProps = ({auth}) => {
    return {auth}
};

export default connect(
    mapStateToProps,
    {addRecipeIngredient}
)(ButtonAddIngredients)
